// extracted by mini-css-extract-plugin
module.exports = {"verticalSpacing":"SponsorsSection_verticalSpacing__jz3Ek","container":"SponsorsSection_container__BHf9j","columnsContainer":"SponsorsSection_columnsContainer__rnWns"};